import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { getAllowedRoles } from '../models/security-roles';
import { CoreStore } from '../store/core.store';

@Injectable({
  providedIn: 'root',
})
export class SecurityRoleGuard implements CanActivate {
  constructor(private readonly router: Router) {}
  store = inject(CoreStore);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    const userRoles = this.store.securityRoles();
    const allowedRoles = getAllowedRoles(state.url);

    if (userRoles.some((role) => allowedRoles.includes(role))) return true;

    if (userRoles.length > 0) {
      this.router.navigate(['/access-denied'], {
        queryParams: { from: state.url },
      });
    }
    return false;
  }
}
